<div>
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>        
    <p class="text-center">{{ data.text | translate : data.parameter}}</p>
</div>


